import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs';
import { response } from '../../optDetail';
import { AppConfig } from '../../../../assets/config/appconfig';
import { AppInsightsService } from '../appinsights/appinsights.service';

@Injectable()
export class ResponseService {
  private responseURL = `${this._appConfig.settings.defaultURL}/v2/response/` ;
  constructor(private http: HttpClient, private _appConfig: AppConfig, private appInsightsService: AppInsightsService) {
  }

  saveResponse(resp: response): Observable<response>{
      let url = `${this.responseURL}`;
      resp.source = 'Web';
    const httpOptions = { headers : new HttpHeaders({ 'Content-Type': 'application/json' })};
    this.appInsightsService.logEvent(`Calling response endpoint: ${url}`);
    return this.http.post<response>(url, resp, httpOptions);
  }
}
